'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACHIEVED = 'Achieved it/positive response';
var NO_ACHIEVED = 'Didn\'t achieve it/negative response';
var MIXED = 'Mixed/some positive/some negative';
var IDK = 'Don\'t know';

var Module4App8 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module4,
    app: state.moduleData.data.module4.app8,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App8, _Component);

  function Module4App8() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App8);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App8.__proto__ || (0, _getPrototypeOf2.default)(Module4App8)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 4,
      appId: 8,
      module: 'Module 3',
      title: 'Goals',
      isCompleted: _this.props.app.isCompleted || false,
      achieveGoal: _this.props.app.achieveGoal || '', // How do you think you went in achieving this goal?
      significantChange: _this.props.app.significantChange || '' // What would you say has been the most significant change that you've made as a result of being part of the
      // Reboot Kids program?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module4App8, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'At the beginning of these modules we asked you to set goals for yourself to achieve in this period.'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'How do you think you went in achieving this goal?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'achieveGoal') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'achieveGoal', value: ACHIEVED, checked: this.state.achieveGoal === ACHIEVED },
                  ACHIEVED
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'achieveGoal', value: NO_ACHIEVED, checked: this.state.achieveGoal === NO_ACHIEVED },
                  NO_ACHIEVED
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'achieveGoal', value: MIXED, checked: this.state.achieveGoal === MIXED },
                  MIXED
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'achieveGoal', value: IDK, checked: this.state.achieveGoal === IDK },
                  IDK
                )
              ),
              this.state.achieveGoal === ACHIEVED && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'That\'s good! It sounds like you\'ve made positive progress towards achieving the goal. Now, what sorts of things do you think you\'ll need to do in order to maintain this?'
                )
              ),
              (this.state.achieveGoal === NO_ACHIEVED || this.state.achieveGoal === MIXED || this.state.achieveGoal === IDK) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'It\'s great that you had a go! Sometimes these things take time, it would be great if you could keep trying!'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Sometimes it takes a number of attempts over a long period of time to bring about changes...'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Is there anything you would do differently '
                    )
                  )
                )
              ),
              this.state.achieveGoal && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'Most significant change'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'What would you say has been the most significant change that you\'ve made as a result of being part of the Reboot Kids program?'
                ),
                _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea', placeholder: 'The most significant change was...',
                  value: this.state.significantChange, onChange: this.handleChange.bind(this, 'significantChange') })
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          ),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module4App8;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4App8;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App8.js
// module id = 1213
// module chunks = 0